import Vue from "vue"
/*************************************************自定义组件*********************************************************/
import PageGroup from "../tool/PageGroup.vue"
import Preview from "../tool/Preview.vue"
import UploadTable from "../tool/UploadTable.vue"
import UploadInput from "../tool/UploadFile.vue"
import Editor from "../tool/Editor.vue"
import EditorInput from "../tool/EditorInput.vue"
import SortTransfer from "../tool/SortTransfer.vue"
import TableButton from "../tool/TableButton.vue"
import FormInput from "../tool/FormInput.vue"
import Uploads from "../tool/UploadFiles.vue"
Vue.component('my-page', PageGroup)
Vue.component('my-preview', Preview)
Vue.component('my-upload-table', UploadTable)
Vue.component('my-upload', UploadInput)
Vue.component('my-uploads', Uploads)
Vue.component('my-edit', Editor)
Vue.component('my-edit-input', EditorInput)
Vue.component('my-sort-transfer', SortTransfer)
Vue.component('my-table-button', TableButton)
Vue.component('my-input', FormInput)
Vue.use(PageGroup);
Vue.use(Preview);
Vue.use(UploadTable);
Vue.use(UploadInput);
Vue.use(SortTransfer);
Vue.use(EditorInput);
Vue.use(TableButton);
Vue.use(FormInput);
Vue.use(Editor);
Vue.use(Uploads);
